import { InputWithSlider } from "Components/Merchant/FeeCalculator/InputWithSlider";
import type { CalculatorFormValues } from "Components/Merchant/FeeCalculator/schema";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { Control } from "react-hook-form";

type Props = {
  control: Control<CalculatorFormValues>;
  label: string;
  name: keyof CalculatorFormValues;
  min?: number;
  max?: number;
  step?: number;
  inputEndAdornment?: string;
};

export const ParameterWidget = ({
  control,
  label,
  name,
  min,
  max,
  step,
  inputEndAdornment,
}: Props) => (
  <PrimaryPaper sx={{ width: "100%", height: "100%" }}>
    <InputWithSlider
      label={label}
      name={name}
      control={control}
      inputEndAdornment={inputEndAdornment}
      min={min}
      max={max}
      step={step}
      inputWidth={48}
    />
  </PrimaryPaper>
);
